import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-error-page',
    imports: [RouterModule],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.css'
})
export class ErrorPageComponent {

  
  constructor(private authService: AuthServiceUser, private router: Router) { }

  navigateBtnClick(){
    this.authService.isErrorPageShown = true;
    this.router.navigate(['/']);
  }
}
